/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Route } from 'react-router';
import { NotFoundPage } from 'sarsaparilla';

import ActivityPassDetailsPageContainer from '../src/containers/ActivityPassDetailsPageContainer';
import PassSelectionPage from '../src/containers/PassSelectionPage';

import routesArray from './routesArray';

const Components = {
    ActivityPassDetailsPageContainer,
    PassSelectionPage,
};

export default function makeSwitchRoutes() {
    const routeComponents = routesArray.map((route) => {
        const Component = Components[route.componentName];

        return <Route key={route.path} path={route.path} element={<Component />} />;
    });

    routeComponents.push(<Route path="*" key="notFound" element={<NotFoundPage />} />);

    return routeComponents;
}
